module.exports = __webpack_public_path__ + "static/media/AI_12.7d8f458a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_12.png
// module id = 127
// module chunks = 0